<template>
  <v-card class="mx-4" elevation="4">
    
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
    <v-list-item three-line>
      <v-list-item-content>
        <div class="text-overline mb-4">Reporte titulaciones</div>
        <v-list-item-title class="text-h5 mb-1"> Reporte de Titulaciones por Sede </v-list-item-title>
      </v-list-item-content>

      <v-btn class="orange darken-4" dark tile @click="bajarExcelSede()">
        <v-icon left>mdi-download</v-icon>
        Descargar Excel
      </v-btn>
    </v-list-item>


    <div class="row px-8">
      <div class="col col-sm-12 col-md-4 col-lg-3">
        <v-select v-model="gestion" :items="gestiones" label="Gestion:" :loading="loading_gestiones" 
          style="z-index: 18" />
      </div>
      <div class="col col-sm-12 col-md-8 col-lg-9">
        <v-btn class="primary" dark tile @click="listarDatos()">
          <v-icon left>mdi-database-search</v-icon>
          Consultar
        </v-btn>
      </div>
      <!-- <div class="col">
                <v-select :items="[]" label="Sede:"/>
            </div> -->
    </div>
    <hr>
    <div >
    
    <v-data-table :fixed-header="true" :loading="isLoading" height="calc(var(--vh, 1vh) * 100 - 19.5rem)" width="300"
      :headers="headers" :items="datos" item-key="id" :items-per-page="500" dense disable-pagination hide-default-footer
      class="elevation-1">
 

      <template v-slot:no-data>
        No existe datos para mostrar
      </template>

      <template v-slot:foot>
        <tfoot>
          <tr>
            <td colspan="1" class="text-right">TOTALES</td>
            <td v-for="header in headers.slice(1)" :key="header.value" class="text-center">
              {{ totales[header.value] }}
            </td>
          </tr>
        </tfoot>
      </template>
    </v-data-table>
  </div>

  </v-card>
</template>

<style>
@import './por_sede.css';
</style>

<script>
import { getHeaders, getDatosSedes, getGestiones, descargarExcelSede } from './index.js';

export default {
  components: {},
  data() {
    return {
      isLoading: false,
      headers: [],
      datos: [],
      totales: {},
      gestiones: [],
      programas: [],
      gestion: null,
      programa: null,
      loading_gestiones: false,
      loading_programas: false,
    };
  },
  watch: {
    // gestion() {
    //   this.listarProgramas();
    // },
    // '$store.state.convenio': function () {
    //   if (this.$store.state.convenio) {
    //     this.listarProgramas();
    //   }
    // },
    // '$store.state.CARGO': function () {
    //   if (this.$store.state.CARGO) {
    //     this.listarProgramas();
    //   }
    // },
    // programa() {
    //   if (!this.programa) {
    //     this.datos = [];
    //     this.totales = {};
    //     return;
    //   }
    //   this.listarDatos();
    // },
  },

  computed: {},
  methods: {
    bajarExcelSede() {
      descargarExcelSede(this.headers, this.datos, this.totales);
    },
    async listarGestiones() {
      this.programa = null;
      this.gestiones = [];
      this.loading_gestiones = true;
      const ges = await getGestiones(this);
      this.gestiones = ges;
      this.loading_gestiones = false;
    },
    // async listarProgramas() {
    //   this.programa = null;
    //   this.programas = [];
    //   this.loading_programas = true;
    //   const idsede = this.$store.state.CARGO.sede.id;
    //   const iduniversidad = this.$store.state.convenio.id;
    //   window.console.log(idsede, iduniversidad);
    //   const pros = await getProgramas(this, idsede, iduniversidad, this.gestion);
    //   this.programas = pros;
    //   this.loading_programas = false;
    // },
    async listarDatos() {
      //const idprograma = this.programa.id;
      this.isLoading = true;
      const anio = this.gestion;
      const sede = this.$store.state.CARGO.sede.id;
      //window.console.log(this.$store.state);
      const convenio = this.$store.state.convenio.id;


      // window.console.log(idprograma, anio, sede);


      const data = await getDatosSedes(sede, anio, convenio);

      this.headers = data.headers;
      this.datos = data.datos;
      this.totales = data.totales;
      this.isLoading = false;
    },
  },
  async mounted() {
    this.listarGestiones();
    this.headers = getHeaders();
    this.datos = [];
    //this.listarDatos();
    // this.listarDatos();
  },
};
</script>
